import Swiper from 'swiper';

const contentsPage = $('#contents').length;
const contentsYofukashiPage = $('#yofukashi').length;

export function contentsFunc() {
  if (contentsPage) {
    if ($('#recommendSlider').length) {
      const breakPoint = 750;
      let mySwiper;
      let mySwiperBool;

      window.addEventListener('resize', () => {
        if (breakPoint < window.innerWidth && mySwiperBool) {
          mySwiper.destroy(false, true);
          mySwiperBool = false;
        } else if (breakPoint >= window.innerWidth && !(mySwiperBool)) {
          createSwiper();
          mySwiperBool = true;
        }
      }, false);

      const createSwiper = () => {
        mySwiper = new Swiper('#recommendSlider', {
          speed: 1500,
          slideToClickedSlide: true,
          slidesPerView: 'auto',
          loop: true,
          centeredSlides: true,
          slidesPerView: 1.5,
          navigation: {
            nextEl: '.recommendNext',
            prevEl: '.recommendPrev',
          },
          breakpoints: {
            751: {
              spaceBetween: 10
            },
            320: {
              spaceBetween: 20
            }
          },
          preloadImages: false,
          lazy: {
            elementClass: 'lazyload',
            loadPrevNextAmount: 2,
            loadPrevNext: true
          }
        });
      }

      if (breakPoint < window.innerWidth) {
        mySwiperBool = false;
      } else {
        createSwiper();
        mySwiperBool = true;
      }
    }

    if ($('#gallerySlider').length) {
      let gallerySwiper, galleryOptions;
      gallerySwiper = undefined;
      galleryOptions = {
        loop: true,
        speed: 800,
        effect: 'slide',
        normalizeSlideIndex: true,
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 1,
        loopAdditionalSlides: 1,
        navigation: {
          nextEl: '.galleryNext',
          prevEl: '.galleryPrev',
        },
        breakpoints: {
          751: {
            spaceBetween: 60
          },
          320: {
            spaceBetween: 20
          }
        },
        preloadImages: false,
        lazy: {
          elementClass: 'lazyload',
          loadPrevNextAmount: 2,
          loadPrevNext: true
        }
      };

      function initGallerySwiper() {
        gallerySwiper = new Swiper('#gallerySlider', galleryOptions);
      }
      initGallerySwiper();
    }

    if ($('#yofukashiPopularitySlider').length) {
      const breakPoint = 750;
      let mySwiper;
      let mySwiperBool;

      window.addEventListener('resize', () => {
        if (breakPoint < window.innerWidth && mySwiperBool) {
          mySwiper.destroy(false, true);
          mySwiperBool = false;
        } else if (breakPoint >= window.innerWidth && !(mySwiperBool)) {
          createSwiper();
          mySwiperBool = true;
        }
      }, false);

      const createSwiper = () => {
        mySwiper = new Swiper('#yofukashiPopularitySlider', {
          speed: 1500,
          slideToClickedSlide: true,
          slidesPerView: 'auto',
          loop: true,
          centeredSlides: true,
          slidesPerView: 1.5,
          navigation: {
            nextEl: '.yofukashiPopularityNext',
            prevEl: '.yofukashiPopularityPrev',
          },
          breakpoints: {
            751: {
              spaceBetween: 10
            },
            320: {
              spaceBetween: 20
            }
          },
          preloadImages: false,
          lazy: {
            elementClass: 'lazyload',
            loadPrevNextAmount: 2,
            loadPrevNext: true
          }
        });
      }

      if (breakPoint < window.innerWidth) {
        mySwiperBool = false;
      } else {
        createSwiper();
        mySwiperBool = true;
      }
    }

    let voiceArchiveList = $('.voiceArchiveList');
    let voiceArchiveListItem = $('.voiceArchiveListItem').length;
    console.log(voiceArchiveListItem);
    if (voiceArchiveListItem % 4 == 3) {
      voiceArchiveList.append('<li class="voiceArchiveListItem pcOnly"></i>');
    } else if (voiceArchiveListItem % 4 == 2) {
      voiceArchiveList.append('<li class="voiceArchiveListItem pcOnly"></i><li class="voiceArchiveListItem pcOnly"></i>');
    } else if (voiceArchiveListItem % 4 == 1) {
      voiceArchiveList.append('<li class="voiceArchiveListItem pcOnly"></i><li class="voiceArchiveListItem pcOnly"></i><li class="voiceArchiveListItem pcOnly"></i>');
    }
  }
}

export function contentsYofukashiFunc() {
  if (contentsYofukashiPage) {
    var headerHeight,position;
    $('a[href^="#"]:not(.notScroll)').each(function () {
      var pageUrl = location.href.split('#')[0];
      if (this.href.indexOf(pageUrl + '#') === 0) {
        var id = this.href.split('#')[1];
        $(this).on('click', function () {
          headerHeight = $('#header').outerHeight(true);
          position = $('#' + id).offset().top - headerHeight - 12;
          $('body,html').animate({
            scrollTop: position
          }, 1000, 'easeInOutQuart');
          return false;
        });
      }
    });

    function equalBoxHeight(elm, num) {
      elm = $(elm);
      elm.css("height", "auto");
      elm.each(function (i) {
        let height;
        let $this = $(this);

        if (i === 0 || i % num === 0) {
          height = $this.height();

          for (let n = i + 1; n <= i + num - 1; n++) {
            if (height < elm.eq(n).height()) {
              height = elm.eq(n).height();
            }
          }

          for (let n = i; n <= i + num - 1; n++) {
            elm.eq(n).css("height", height + "px");
          }
        }
      });
    }

    const breakPoint = 750;

    if (breakPoint < window.innerWidth) {
      equalBoxHeight('.yofukashiArchiveListItemTit', 3);
      equalBoxHeight('.yofukashiRecommendSlideTit', 3);
      equalBoxHeight('.yofukashiPopularitySlideTit', 3);
    } else {
      equalBoxHeight('.yofukashiArchiveListItemTit', 2);
      equalBoxHeight('.yofukashiRecommendSlideTit', 7);
      equalBoxHeight('.yofukashiPopularitySlideTit', 7);
    }
  }
}